import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
const formatDriveImage = (url) => {
  if (!url) return null;

  if (url.includes("drive.google.com")) {
    const match = url.match(/\/d\/([^/]+)/);
    if (match?.[1]) {
      return `https://drive.google.com/thumbnail?id=${match[1]}&sz=w1200`;
    }
  }

  return url;
};

const NewsDetail = () => {
  window.scrollTo(0, 0);
  const { slug } = useParams();
  const [news, setNews] = useState(null);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    fetch(`https://sattva-backend.demetrix.in/news`)
      .then(res => res.json())
      .then(data => {
        if (data.status === "success") {
          const found = data.data.find(
            item =>
              item.slug === slug &&
              item.is_published &&
              !item.is_deleted
          );
          setNews(found || null);
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-slate-950">
        <div className="flex flex-col items-center gap-4">
          {/* Spinner */}
          <div className="w-12 h-12 border-4 border-gray-300 dark:border-slate-700 
                        border-t-gray-900 dark:border-t-white 
                        rounded-full animate-spin">
          </div>

          {/* Optional text */}
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Loading news...
          </p>
        </div>
      </div>
    );
  }

  if (!news) return <p className="pt-20 text-center">News not found</p>;

  /* ===== IMAGE FIX ===== */
  const imageMedia = news.media?.find(m => m.type === "image");
  let imageUrl = null;

  if (imageMedia?.url?.includes("drive.google.com")) {
    const id = imageMedia.url.match(/\/d\/([^/]+)/)?.[1];
    if (id) {
      imageUrl = `https://drive.google.com/thumbnail?id=${id}&sz=w1200`;
    }
  }

  /* ===== VIDEO FIX ===== */
  const videoMedia = news.media?.find(m => m.type === "video");
  let videoUrl = null;

  if (videoMedia?.url?.includes("youtube.com")) {
    const id = videoMedia.url.match(/v=([^&]+)/)?.[1];
    if (id) {
      videoUrl = `https://www.youtube.com/embed/${id}`;
    }
  }

  return (
    <div className="min-h-screen pt-20 pb-20 max-w-4xl mx-auto p-6">
      <div className="flex flex-col md:flex-row items-center justify-between md:gap-4 mb-4">
        {/* Title */}
        <h1 className="text-3xl font-bold mb-4 pt-16">{news.title}</h1>

        <div className="">
          <button
            onClick={() => navigate(-1)}
            className="px-4 py-2 text-sm font-medium text-primary border border-primary rounded-lg hover:bg-primary/10 transition-colors dark:text-primary dark:hover:bg-primary/20"
          >
            Close
          </button>
        </div>

      </div>

      <span className="text-xs border px-3 py-1 rounded-full text-green-700 border-green-600 mb-6 inline-block">
        {news.slug}
      </span>

      {/* Text + Image Row */}
      <div className="grid md:grid-cols-3 gap-6 mb-10 items-start">

        {/* Text */}
        <div className="md:col-span-2 text-gray-700 whitespace-pre-line leading-relaxed">
          {news.content}
        </div>

        {/* Image */}
        {imageUrl && (
          <div className="md:col-span-1">
            <img
              src={formatDriveImage(imageMedia.url)}
              alt={news.title}
              className="w-full rounded-lg"
              loading="lazy"
              referrerPolicy="no-referrer"
              onError={(e) => {
                e.currentTarget.src = "/placeholder.jpg"; // optional fallback
              }}
            />
          </div>
        )}

      </div>

      {/* Video */}
      {videoUrl && (
        <div className="mt-10">
          <iframe
            src={videoUrl}
            className="w-full h-[400px] rounded-lg"
            allowFullScreen
            title="News Video"
          />
        </div>
      )}

    </div>

  );
};

export default NewsDetail;
